import React from 'react';
import PropTypes from 'prop-types';
import {Button, Card, Col, Icon, Input, Row, Table} from "antd";
import {firstPage} from "../utils/pagination";
import Screen from '../utils/screen';
import "./ListView.css";
import ResponsiveTable from "./ResponsiveTable";

export default class ListView extends React.Component {
  static propTypes = {
    ...Table.propTypes,

    title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    addText: PropTypes.string,
    searchPlaceholder: PropTypes.string,

    dataSourceProvider: PropTypes.func.isRequired,

    dispensaryId: PropTypes.string, // TODO need to extract dispensaryId from here
    searchFilter: PropTypes.string,
    filters: PropTypes.object,
    sorter: PropTypes.object,

    onAdd: PropTypes.func,
    onPrint: PropTypes.func,
    children: PropTypes.node,
  };

  static defaultProps = {
    addText: 'Add',
    searchPlaceholder: 'Search'
  };

  constructor(props) {
    super(props);
    const {searchFilter} = this.props;
    this.state = {searchFilter};
  }

  componentDidMount() {
    const {pagination, filters, sorter} = this.props;
    this.load(pagination, filters, sorter);
  }

  componentDidUpdate(prevProps) {
    const {dispensaryId} = this.props;
    if (dispensaryId !== prevProps.dispensaryId) this.load(firstPage);
  }

  load = (pagination, filters = {}, sorter = {}) => {
    const {dispensaryId} = this.props;
    if (dispensaryId) {
      filters = {...filters, dispensaryId};
    }
    const {field, order} = sorter;
    sorter = field && order && {field, order};
    const {searchFilter} = this.state;
    this.props.dataSourceProvider({pagination, filters, sorter, searchFilter});
  };

  refresh = () => {
    const {pagination, filters, sorter} = this.props;
    this.load(pagination, filters, sorter);
  };

  onAddClick = () => {
    this.props.onAdd();
  };

  onFilterChange = (evt) => {
    if (this._searchTimeout) clearTimeout(this._searchTimeout);
    this.setState({searchFilter: evt.target.value});
    this._searchTimeout = setTimeout(this.load, 300, firstPage, {}, {});
  };

  render() {
    const {searchFilter} = this.state;
    const {
      // Card
      title, children,
      // Button
      addText, onAdd, onPrint,
      // Search
      searchPlaceholder,
      // Table
      ...tableProps
    } = this.props;
    const isMobile = ['xs', 'sm'].includes(Screen.size);
    const isScreenExtraSmall = Screen.size === 'xs';
    const buttons = [];
    if (onPrint) buttons.push(<Button key="print-button" icon="printer" onClick={onPrint}>Print</Button>);
    if (onAdd) buttons.push(<Button key="add-button" type="primary" icon="plus" onClick={this.onAddClick}>{addText}</Button>);
    const searchInput = <Input
      value={searchFilter}
      addonBefore={<Icon type="search"/>}
      placeholder={searchPlaceholder}
      autoFocus={!isMobile}
      onChange={this.onFilterChange}
      onFocus={e => e.target.select()}
    />;
    const cardTitle = isScreenExtraSmall ? title : <Row>
      <Col span={onAdd ? 10 : 12} style={{whiteSpace: 'normal'}}>{title}</Col>
      <Col span={12}>{searchInput}</Col>
    </Row>;
    delete tableProps.onChange;
    return (
      <Card title={cardTitle} extra={buttons}>
        {children}
        {isScreenExtraSmall && searchInput}
        <ResponsiveTable
          onChange={this.load}
          {...tableProps}
          noResize={false}
        />
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/ListView.js